import React, { useEffect, useRef, useState } from "react";
import BaseLayout from "../../components/layout/BaseLayout";
import { DataState } from "../../context/DataProvider";
import AutoResizableTextarea from "../../components/AutoResizableTextarea";
import { MdAdd } from "react-icons/md";
import SelectedTriggerItem from "../../components/form/SelectedTriggerItem";
import { createTempBot } from "../../services/api";
import Button from "../../components/custom/Button";
import TriggerModal from "../../components/form/TriggerModal";
import {
  dataSources,
  integrationData
} from "../../utils/constants";
import { FaArrowLeftLong, FaS } from "react-icons/fa6";
import QuestionForm from "../../components/form/QuestionForm";
import Modal from "../../components/Modal";
import KanbanBoard from "../../components/kanbanboard/KanbanBoard";
import Backlog from "../../components/backlog/Backlog";
import { useLocation } from "react-router-dom";
import { FiLayers } from "react-icons/fi";
import { IoCheckmark } from "react-icons/io5";

import AripDashboard from "../arip/DashBoard";

import TaskManagementDashboard from "../arip/TaskDashboard";
import SmartAlerts from "../arip/SmartAlerts";
import OqlousCTA from "../../components/Logo";
import useClickOutside from "../../hooks/useClickOutside";

const CreateMeetingForm = ({ isModalOpen, closeModal }) => {
  const [isTriggerModalOpen, setIsTriggerModalOpen] = useState(false);
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);
  const [isDataSourceModalOpen, setIsDataSourceModalOpen] = useState(false);

  const [selectTrigerOptions, setSelectTrigerOptions] = useState([]);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const {
    createAndHandleClarificationQuestions,
    setError,
    botCreationId,
    setBotCreationId,
    userGoogleId,
  } = DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState(""); // State for storing the trigger name
  const [instruction, setInstruction] = useState(""); // State for storing the instruction
  const [meetingName, setMeetingName] = useState(""); // State for storing the instruction
  const [meetingLink, setMeetingLink] = useState(""); // State for storing the instruction
  const [meetingTiming, setMeetingTiming] = useState(""); // State for storing the instruction

  useEffect(() => {
    if (isModalOpen) {
      const createBot = async () => {
        try {
          const response = await createTempBot({}, userGoogleId);
          if (response.error) {
            setError(JSON.stringify(response.error));
            console.log("Temp bot creation error:", response.error);
            return;
          }
          if (response.bot_id) {
            console.log("Created temp bot:", response.bot_id);
            setBotCreationId(response.bot_id);
          }
        } catch (err) {
          setError(JSON.stringify(err));
          console.log("Temp bot creation error:", err);
        }
      };
      createBot();
    }
  }, [isModalOpen]);

  const handleDeleteOption = (optionId) => {
    setSelectTrigerOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleDeleteDataSourceOption = (optionId) => {
    setSelectDataSourceOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };
  const handleTriggerEditOption = (option) => {
    setEditOption(option);
    setIsTriggerModalOpen(true);
  };
  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };
  const handleDataSourceEditOption = (option) => {
    setEditOption(option);
    setIsDataSourceModalOpen(true);
  };

  const [showQuestionForm, setShowQuestionForm] = useState();
  const [showTestScreen, setShowTestScreen] = useState();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const clearStates = () => {
    setSelectTrigerOptions([]);
    setSelectIntegrationOptions([]);
    setSelectDataSourceOptions([]);
    setTriggerName("");
    setInstruction("");
  };
  const handleNewInstructionSubmission = async () => {
    setIsFormLoading(true);
    try {
      const final_response = await createAndHandleClarificationQuestions(
        instruction,
        triggerName,
        selectTrigerOptions,
        selectIntegrationOptions,
        selectDataSourceOptions
      );
      if (final_response && final_response.questions) {
        setShowQuestionForm(true);
      } else {
        console.log("No Questions Returned");
      }
    } catch (error) {
    } finally {
      setIsFormLoading(false);
    }
  };
  const handleShowTestScreen = () => {
    setShowTestScreen(true);
  };

  return (
    <div className="flex items-center justify-center duration-200">
      {!showTestScreen && !showQuestionForm && (
        <div className="w-full overflow-auto rounded-lg bg-2">
          <div className="flex flex-col gap-8 p-6">
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Name of the Meeting Co Pilot
                </h1>
              </div>
              <input
                value={meetingName}
                onChange={(e) => setMeetingName(e.target.value)} // Update instruction state
                className="px-4 py-2 text-base bg-transparent border rounded-lg outline-none resize-none bg-2 br-1"
                placeholder=""
              />
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Meeting instructions
                </h1>
              </div>
              <textarea
                value={instruction}
                onChange={(e) => setInstruction(e.target.value)} // Update instruction state
                className="px-4 py-2 text-base bg-transparent border rounded-lg outline-none resize-none h-52 bg-2 br-1"
                placeholder="Instructions describe your workflow requirements in detail. Include all necessary steps, data processing instructions, and desired outcomes across integrated applications (e.g. Jira, Email, Sheets, Docs). Example: 'For every email received in the inbox, send an automated apology response explaining a 34 hour delay in support. Then, create a Jira task under the 'Support' Project, including the email content and tagging it as 'High Priority'. Notify the team lead in Slack once task is created."
              />
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="p-2 text-sm transition-all duration-200 bg-1"
                >
                  <MdAdd />
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">Data sources</h1>
                  <p className="text-sm">
                    Add data sources required in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsDataSourceModalOpen(true)}
                  className="p-2 text-sm transition-all duration-200 bg-1"
                >
                  <MdAdd />
                </button>
              </div>
              {selectDataSourceOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleDataSourceEditOption(item)}
                  handleDeleteOption={handleDeleteDataSourceOption}
                />
              ))}
            </div>
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">Meeting link</h1>
              </div>
              <input
                value={meetingLink}
                onChange={(e) => setMeetingLink(e.target.value)} // Update instruction state
                className="px-4 py-2 text-base bg-transparent border rounded-lg outline-none resize-none bg-2 br-1"
                placeholder=""
              />
            </div>{" "}
            <div className="flex flex-col gap-1">
              <div className="flex flex-col gap-1">
                <h1 className="text-base font-semibold">
                  Timing of the Meeting
                </h1>
              </div>
              <input
                value={meetingTiming}
                type={"datetime-local"}
                onChange={(e) => setMeetingTiming(e.target.value)} // Update instruction state
                className="px-4 py-2 text-base bg-transparent border rounded-lg outline-none resize-none bg-2 br-1"
                placeholder=""
              />
            </div>
            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Continue
              </Button>
            </div>
            {botCreationId && (
              <TriggerModal
                title="Add integration"
                desc=" Select the app you’d like to add as integration."
                isOpen={isIntegrationModalOpen}
                onClose={() => {
                  setIsIntegrationModalOpen(false);
                  setEditOption(null);
                }}
                appsData={integrationData}
                selectedOptions={selectIntegrationOptions}
                setSelectedOptions={setSelectIntegrationOptions}
                editOption={editOption}
                botCreationId={botCreationId}
              />
            )}
            {botCreationId && (
              <TriggerModal
                title="Add data source"
                desc=" Select the app you’d like to add the data source from."
                isOpen={isDataSourceModalOpen}
                onClose={() => {
                  setIsDataSourceModalOpen(false);
                  setEditOption(null);
                }}
                appsData={dataSources}
                selectedOptions={selectDataSourceOptions}
                setSelectedOptions={setSelectDataSourceOptions}
                editOption={editOption}
                botCreationId={botCreationId}
              />
            )}
          </div>
        </div>
      )}
      {showQuestionForm && !showTestScreen && (
        <div className="bg-zinc-900 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 px-3 py-5 border-b border-zinc-800">
            <div className="px-3 py-1.5 bg-transparent text-xl font-bold flex items-center gap-3">
              <button
                onClick={() => setShowQuestionForm(false)}
                className="bg-2 transition-all duration-200 rounded-lg p-1.5"
              >
                <FaArrowLeftLong />
              </button>
              Clarification Questions
            </div>
            <div></div>
          </div>
          <div className="flex flex-col gap-8 p-6">
            <QuestionForm
              handleShowTestScreen={handleShowTestScreen}
              closeModal={closeModal}
              setShowQuestionForm={setShowQuestionForm}
              clearStates={clearStates}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const MeetingDetails = () => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [expandedTile, setExpandedTile] = useState(null); // State for expanded tile
  const { bots } = DataState();
  const walletAddressRef = useRef(null);

  const toggleDropdown = (botId) => {
    setDropdownOpen((prev) => (prev === botId ? null : botId));
  };

  const toggleExpand = (id) => {
    setExpandedTile((prev) => (prev === id ? null : id));
  };

  useClickOutside([walletAddressRef], () => toggleDropdown(null));

  const [selectedTab, setSelectedTab] = useState("actionable");
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useClickOutside([wrapperRef], () => setOpen(false));

  return (
    <div className="relative w-full h-full py-2 pb-10 -mt-2 rounded-lg">
      {/* ================= HORIZONTAL VIEW SWITCHER ================= */}
      <div
        ref={wrapperRef}
        className="absolute top-0 z-50 right-4 sm:right-12 md:right-6 lg:right-4"
      >
        {/* ICON (fixed position) */}
        <div className="relative flex items-center">
          <button
            onClick={() => setOpen(prev => !prev)}
            className={`w-9 h-9 rounded-full border br-1 bg-3
                        flex items-center justify-center
                        transition-all duration-200 hover:bg-2
                        ${open ? "shadow-md" : "shadow-sm"}`}
          >
            <FiLayers
              className={`text-sm text-p-text transition-transform duration-300
                          ${open ? "rotate-90" : "rotate-0"}`}
            />
          </button>

          {/* SLIDING MENU - MODIFIED TO OPEN LEFT */}
          <div
            className={`absolute right-full top-1/2 -translate-y-1/2
                        flex items-center gap-1 bg-1 border br-1 rounded-full
                        shadow-md overflow-hidden transition-all duration-300
                        ${open
                          ? "max-w-[320px] opacity-100 px-2 mr-2" // RIGHT-HANDED MARGIN
                          : "max-w-0 opacity-0 px-0 ml-0"
                        }`}
          >
            {/* ARIP Dashboard */}
            <button
              onClick={() => {
                setSelectedTab("actionable");
                setOpen(false);
              }}
              className={`px-3 py-1 text-xs rounded-full flex items-center gap-1
                          transition-colors ${
                            selectedTab === "actionable"
                              ? "bg-2 font-medium text-p-text"
                              : "text-p-text hover:bg-2"
                          }`}
            >
              Dashboard
              {selectedTab === "actionable" && (
                <IoCheckmark className="text-sm" />
              )}
            </button>

            {/* Task Management */}
            <button
              onClick={() => {
                setSelectedTab("notes");
                setOpen(false);
              }}
              className={`px-3 py-1 text-xs rounded-full flex items-center gap-1
                          transition-colors ${
                            selectedTab === "notes"
                              ? "bg-2 font-medium text-p-text"
                              : "text-p-text hover:bg-2"
                          }`}
            >
              Tasks
              {selectedTab === "notes" && (
                <IoCheckmark className="text-sm" />
              )}
            </button>

            {/* Smart Alerts */}
            <button
              onClick={() => {
                setSelectedTab("alerts");
                setOpen(false);
              }}
              className={`px-3 py-1 text-xs rounded-full flex items-center gap-1
                          transition-colors ${
                            selectedTab === "alerts"
                              ? "bg-2 font-medium text-p-text"
                              : "text-p-text hover:bg-2"
                          }`}
            >
              Alerts
              {selectedTab === "alerts" && (
                <IoCheckmark className="text-sm" />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* ================= CONTENT ================= */}
      <div className="mt-6">
        {selectedTab === "actionable" && <AripDashboard/>}
        {selectedTab === "notes" && <TaskManagementDashboard/>}
        {selectedTab === "alerts" && <SmartAlerts/>}
      </div>
    </div>
  );
};

const Meeting = () => {
  const location = useLocation();
  const { pathname } = location;
  const { userInfo } = DataState();
  const [openCreate, setOpenCreate] = useState(false);
  const openCreateModal = () => {
    setOpenCreate(true);
  };
  const closeCreateModal = () => {
    setOpenCreate(false);
  };
  const [input, setInput] = useState("");

  return (
    <BaseLayout
      createName="New Meeting"
      handleCreate={openCreateModal}
    >
      <div className="flex flex-col w-full h-full gap-3 px-1 mx-auto">
        {false ? (
          <>
            {userInfo && (
              <div className="flex items-center gap-2">
                <img
                  src={userInfo.picture}
                  className="object-cover w-8 h-8 rounded-full"
                />
                <span className="text-sm">{userInfo.name}</span>
              </div>
            )}
            <div className="flex flex-col items-center justify-center flex-1 gap-10">
              <div className="w-full">
                {/* <h1 className="text-5xl font-bold leading-snug">
                  <span className="mr-2 font-bold gradient-text">Namaste!</span>
                  I'm Oqlous AI
                  <br />
                  Let’s Me Automate your Actionalble items from Meeting
                </h1> */}
                <OqlousCTA/>
                <h2 className="text-3xl text-zinc-500">
                  Create your Meeting Co Pilot{" "}
                </h2>
              </div>
            </div>
          </>
        ) : (
          <MeetingDetails />
        )}
        {pathname !== "/meeting" && (
          <div className="relative">
            <button
              onClick={openCreateModal}
              className="absolute flex items-center gap-2 px-3 py-1 transition-all duration-200 transform -translate-x-1/2 border rounded-lg -top-11 left-1/2 bg-zinc-800 hover:bg-opacity-70 border-zinc-700"
            >
              + Meeting Co Pilot
            </button>
            <AutoResizableTextarea
              setInput={setInput}
              input={input}
              handleSend={() => {}}
            />
          </div>
        )}
      </div>
      <Modal
        title="Create Meeting"
        isOpen={openCreate}
        onClose={closeCreateModal}
      >
        <CreateMeetingForm />
      </Modal>
    </BaseLayout>
  );
};

export default Meeting;